import { action, makeAutoObservable, observable, runInAction } from "mobx";
import { MessageBoxService } from "../components/dialogs/MessageBox";
import { AuthContext } from "./AuthContext";
import { Appl } from "../Appl";

export class ProblemDetails {
    methodName?: string;
    errors?: Array<ValidationError>;
    status?: number;
    title?: string;
    detail?: string;
    instance?: string;
    traceId?: string;
    tileStamp?: string;
    stackTrace?: string;
    route?: string;
}

export class ValidationError {
    pointer?: string;
    detail?: string;
}


export interface IErrorService {
    items: Map<string, string>;
    clear(): void;
    add(key: string, value: string): void;
    remove(key: string): void;
    count(): number;
    handle(problem?: ProblemDetails, isSquareCorner?: boolean): void;
    getValidationError(problem?: ProblemDetails): ValidationError;
}

export class ErrorService implements IErrorService {

    private static _instance: ErrorService;
    public static get instance() {
        return this._instance ?? (this._instance = new ErrorService());
    }

    @observable public items = new Map<string, string>();

    constructor() {
        makeAutoObservable(this);
    }

    @action public clear(): void {
        this.items.clear();
    }

    @action public add(key: string, value: string): void {
        this.items.set(key, value);
    }

    @action public remove(key: string): void {
        this.items.delete(key);
    }

    @action public count(): number {
        return this.items.size;
    }

    @action public handle(problem?: ProblemDetails, isSquareCorner: boolean = false): void {
        let message = this.getValidationError(problem);
        let title = message.pointer;
        if(title){
            title = title.charAt(0).toUpperCase() + title.slice(1)
        }
        MessageBoxService.instance.show(message.detail!, title ?? 'Error', '', 'Okay', isSquareCorner);
    }

    @action public getValidationError(problem?: ProblemDetails): ValidationError {
        let validationError: ValidationError = new ValidationError();
        runInAction(() => {
            this.items.clear();
            if (problem) {
                if (typeof problem === "string") {
                    problem = JSON.parse(problem);
                }
                if (problem) {
                    if (problem.status === 401) {
                        Appl.ConfirmBox.show('Your session has been expired.', 'Session Expired', '', 'Login', 'Close', async () => await AuthContext.instance.signInAsync("AzureAD", "", ""))
                    } else {
                        if (problem.errors) {
                            problem.errors.map((error) => {
                                var element = document.getElementById(error.pointer!)
                                if (element) {
                                    this.items.set(error.pointer!, error.detail!);
                                    validationError.pointer = error.pointer!
                                    validationError.detail = error.detail!
                                } else {
                                    // MessageBoxService.instance.show(error.detail!, problem?.title ?? 'Error');
                                    validationError.pointer = error.pointer;
                                    validationError.detail = error.detail!
                                }
                            })
                        } else {
                            // MessageBoxService.instance.show(problem.detail!, problem.title ?? 'Error');
                            validationError.pointer = "Error";
                            validationError.detail = problem.detail!
                        }
                    }
                }
            }
        })
        return validationError;
    }
}